export enum PRAY_OBJECT_TYPE {
  COMMENT = 'comment',
  USER = 'user',
  PUBLICATION = 'publication',
  INTENTION = 'intention',
  BIRTHDAY = 'birthdayIntention',
  ARRIVAL = 'arrivalIntention',
}
